import type { EntityBatchSyncStatus } from './entityMutationSync'
import { deriveSyncOutcome, type SyncOutcome } from './syncOutcome'

// Thin per-surface wrapper. Logic lives in `deriveSyncOutcome` so every
// surface stays in lockstep (v2.1 finding #24 consolidation).
export type EditFarmSyncOutcome = SyncOutcome

export const deriveEditFarmSyncOutcome = (params: {
  status: EntityBatchSyncStatus
  skippedNotFoundCount: number
}): EditFarmSyncOutcome => deriveSyncOutcome({ ...params, surfaceKey: 'editFarm' })
